// contexts/BaseManager.js
import React, { createContext, useContext, useState } from 'react';

// Create context
const BaseManager = createContext();

// Provider component
export const BaseManagerProvider = ({ children }) => {
    const [isSync, setIsSync] = useState(false);
    const [timeIn, setTimeIn] = useState(false);
    const [timeOut, setTimeOut] = useState(false);
    const [coverageSearch, setCoverageSearch] = useState('');
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

    return (
        <BaseManager.Provider value={
            {
                isSync, setIsSync,
                timeIn, setTimeIn,
                timeOut, setTimeOut,
                coverageSearch, setCoverageSearch,
                isSidebarCollapsed, setIsSidebarCollapsed
            }
        }>
            {children}
        </BaseManager.Provider>
    );
};

// Hook to use sync context
export const useBaseProvider = () => {
    const context = useContext(BaseManager);
    return context;
};
